/**
 * Single source of truth for Google review stats (count + rating).
 *
 * Imported by:
 *  - src/components/Hero.tsx, ReviewsSection.tsx, StatsBar.tsx,
 *    QuoteModal.tsx, QuickQuoteForm.tsx, GoogleReviewsCarousel.tsx
 *  - src/data/cityData.ts (all city pages)
 *  - src/hooks/usePageSEO.ts (runtime LocalBusiness JSON-LD fallback)
 *  - scripts/generate-seo-html.mjs (canonical prerendered aggregateRating —
 *    fetches the LIVE count at build time and only falls back to these values)
 *  - src/lib/mcp/tools/get-company-info.ts
 *
 * Never hardcode a review count or rating anywhere else.
 * Last manually verified against the live Google Business Profile: 2026-10-30.
 */
export const REVIEW_STATS = {
  count: 104,
  rating: 5.0,
};

/** Google wants ratingValue to one decimal place. Handles 4.9 / 4.8 gracefully. */
export const formatRating = (rating = REVIEW_STATS.rating) => Number(rating).toFixed(1);

/** Canonical display string for the rating, e.g. "5.0". */
export const REVIEW_RATING_TEXT = formatRating();

/** Supabase edge function that returns { rating, reviewCount, reviews }. */
export const REVIEWS_ENDPOINT =
  "https://zqfuscahbvhignmbnlgx.supabase.co/functions/v1/google-reviews";
